import { render, staticRenderFns } from "./sidebarRight.vue?vue&type=template&id=4a1480c9&"
import script from "./sidebarRight.vue?vue&type=script&lang=ts&"
export * from "./sidebarRight.vue?vue&type=script&lang=ts&"
import style0 from "./sidebarRight.vue?vue&type=style&index=0&id=4a1480c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports